var React = require('react');

function TestimonialIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.28657 1.69315C4.83595 3.53331 1.96481 7.72477 1.76155 14.2501H13C13.4142 14.2501 13.75 14.5858 13.75 15.0001V29.0001C13.75 29.4143 13.4142 29.7501 13 29.7501H1C0.585786 29.7501 0.25 29.4143 0.25 29.0001V15.0001C0.25 7.58229 3.41123 2.49922 8.71343 0.30696L9.28657 1.69315ZM1.75 28.2501V15.7501H12.25V28.2501H1.75ZM27.2866 1.69315C22.836 3.53331 19.9648 7.72477 19.7616 14.2501H31C31.4142 14.2501 31.75 14.5858 31.75 15.0001V29.0001C31.75 29.4143 31.4142 29.7501 31 29.7501H19C18.5858 29.7501 18.25 29.4143 18.25 29.0001V15.0001C18.25 7.58229 21.4112 2.49922 26.7134 0.30696L27.2866 1.69315ZM19.75 28.2501V15.7501H30.25V28.2501H19.75Z","fill":"#C966FF"}));
}

TestimonialIcon.defaultProps = {"width":"32","height":"30","viewBox":"0 0 32 30","fill":"none"};

module.exports = TestimonialIcon;

TestimonialIcon.default = TestimonialIcon;
